<template>
  <div class="datepicker control">
    <v-date-picker
      v-model="computedValue"
      :mode="mode"
      :first-day-of-week="firstDayOfWeek"
      :masks="{ input: maskedInput }"
      :min-date="minDate"
      :max-date="maxDate"
      :popover="popover"
      @dayclick="
        (day, event) => {
          event.target.blur();
        }
      "
    >
      <template v-slot="{ inputValue, inputEvents }">
        <div class="control">
          <input
            type="text"
            :placeholder="placeholder"
            class="input focus:outline-none focus:border-primary-500"
            :value="inputValue"
            v-on="inputEvents"
          />
        </div>
      </template>
    </v-date-picker>
  </div>
</template>

<script>
import FormElementMixin from "@mixins/formElementMixin";

export default {
  name: "DDatepicker",

  mixins: [FormElementMixin],
  props: {
    modelValue: {
      type: [Date, String],
      default: null,
    },

    popover: {
      type: Object,
      default: () => ({ visibility: "click" }),
    },

    /*
     * Sets the selection view
     * @parameters `date`, `dateTime`, `time`
     */
    mode: {
      type: String,
      default: "date",
    },

    /*
     * Day number for the first day of the week (1: Sun - 7: Sat). Ignore setting this prop if you want to allow the locale to determine this setting.
     */
    firstDayOfWeek: {
      type: Number,
      default: 1, // Default to Sunday (1)
    },
    minDate: {
      type: [Date, undefined],
      default: undefined,
    },
    maxDate: {
      type: [Date, undefined],
      default: undefined,
    },
    placeholder: String,
    disabled: Boolean,
    events: Array,
  },

  emits: ["update:modelValue"],

  computed: {
    computedValue: {
      get() {
        const timestamp = Date.parse(this.modelValue);
        if (this.modelValue && !isNaN(timestamp)) {
          return new Date(this.modelValue);
        }

        return this.modelValue;
      },
      set(value) {
        // Ensure we're working with a valid date object
        if (value instanceof Date || (value && !isNaN(Date.parse(value)))) {
          this.$emit("update:modelValue", value);
        } else {
          this.$emit("update:modelValue", null);
        }
      },
    },

    maskedInput() {
      if (this.mode === "dateTime") {
        return "MM/DD/YYYY h:mmA";
      }
      if (this.mode === "time") {
        return "h:mmA";
      }
      return "MM/DD/YYYY";
    },
  },
};
</script>
